import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import useStyles from "../../styles/styles";
import React from "react";

const VendorPauseDeleteConfirmation = ({onClose, open, selected}) => {
    const classes = useStyles();

    const handleCancel = () => {
        onClose(true);
    };

    const handleConfirm = () => {
        onClose(false);
    };

    return (
        <Dialog onClose={handleCancel} open={open} maxWidth={"lg"}>
            <DialogTitle>
                <Typography variant="h6" align="center" style={{margin: '15px 10px 10px'}}>
                    Are you sure you want to delete the following Vendor Pauses?
                </Typography>
            </DialogTitle>
            <Paper className={classes.paper}>
                <TableContainer>
                    <Table sx={{minWidth: 650}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">ID</TableCell>
                                <TableCell align="center">servicer</TableCell>
                                <TableCell align="center">porfolio</TableCell>
                                <TableCell align="center">campaign</TableCell>
                                <TableCell align="center">startDate</TableCell>
                                <TableCell align="center">expiration</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selected.map((row) => (
                                <TableRow
                                    key={row.id}
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell align="center">{row.id}</TableCell>
                                    <TableCell align="center">{row.servicer}</TableCell>
                                    <TableCell align="center">{row.portfolio}</TableCell>
                                    <TableCell align="center">{row.campaign}</TableCell>
                                    <TableCell align="center">{row.startDate}</TableCell>
                                    <TableCell align="center">{row.expiration}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <Box
                display={"flex"}
                alignItems={"center"}
                style={{margin: '10px 0'}}
                justifyContent={"center"}>
                <Box style={{marginRight: '10px'}}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            handleConfirm();
                        }}
                    >
                        Confirm
                    </Button>
                </Box>
                <Box>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                            handleCancel();
                        }}
                    >
                        Cancel
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
}

export default VendorPauseDeleteConfirmation